import getDisplayName from "@gef-ui/utils/getDisplayName";
import mergeDefaultProps from "@gef-ui/utils/mergeDefaultProps";
import hoistNonReactStatics from 'hoist-non-react-statics';
import curry from "ramda/es/curry";
import React, { forwardRef } from 'react';
import { useDefaultComponentValue } from '../../utils/useDefaultComponentValue';
export const withDefaultComponentProps = curry((componentName, defaultProps, WrappedComponent)=>{
    const WithDefaultPropsWrapping = /*#__PURE__*/ forwardRef((inProps, ref)=>{
        const props = useDefaultComponentValue({
            inProps,
            name: componentName
        });
        return /*#__PURE__*/ React.createElement(WrappedComponent, {
            ref: ref,
            ...mergeDefaultProps(props, defaultProps)
        });
    });
    WithDefaultPropsWrapping.displayName = `withDefaultPropsMapping(${getDisplayName(WrappedComponent)})`;
    hoistNonReactStatics(WithDefaultPropsWrapping, WrappedComponent);
    return WithDefaultPropsWrapping;
});
